import { render, staticRenderFns } from "./confirmPass.vue?vue&type=template&id=f31bb5a6&scoped=true"
import script from "./confirmPass.vue?vue&type=script&lang=js"
export * from "./confirmPass.vue?vue&type=script&lang=js"
import style0 from "./confirmPass.vue?vue&type=style&index=0&id=f31bb5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f31bb5a6",
  null
  
)

export default component.exports